module.exports = __webpack_public_path__ + "assets/img/rule.5bffe10a.png";